import React, { useEffect, useState } from "react";
import useAxiosInstance from "../../hooks/useAxios";
import FilterModal from "../../components/FilterModal";
import { Paginator } from "../../components/Paginator";
import { Table } from "flowbite-react";
import { TableCustom } from "../../components/Table";
import { Filter1Outlined } from "@mui/icons-material";
import { FaFilter } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { PRODUCT_VIDEO_TABLE_KEYS } from "../../helper";
import { toast } from "react-toastify";

const AllProductVideo = () => {
    const axiosInstance = useAxiosInstance();
    const history = useNavigate();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    
    useEffect(() => {
        setLoading(true);
        axiosInstance
          .get("/assets/get_all_product_videos/")
          .then((res) => {
            setLoading(false);
            setData(res.data || []);
          })
          .catch((err) => {
            setLoading(false);
          });
      }, []);

    return (
        <div className="p-2 overflow-x-auto bg-slate-100 mt-4 rounded-xl">
            <div className="flex justify-between">
                <span className="text-xl font-medium">Product Video</span>
                <div className="flex items-center gap-x-2">
                    <button className="text-sm bg-black py-1 px-2 rounded-lg text-white" onClick={() => history('/addProductVideo')}>Add Product Video</button>
                </div>
            </div>

            <TableCustom
                columns={PRODUCT_VIDEO_TABLE_KEYS}
                data={{data:data}}
                loading={loading}
                handleEdit={(id) => {
                    history(`/EditProductVideo?product_video_id=${id}`)
                }}
                handleDelete={(id) => {
                    console.log(id)
                    const is_on = window.confirm(`are you sure you want to delete this video ${id} ?`)
                    if(!is_on){
                        return 
                    }
                    axiosInstance.post(`/assets/delete_a_product_video/`, { product_video_pk:id }).then(res => {
                        if (res.status === 200) {
                            toast.success(
                                'deleted!'
                            )
                        } else {
                            toast.error('Failed!')
                        }
                    }).catch(err => {
                        toast.error(
                            'Failed!'
                        )
                    })
                }}
            />
        </div>
    );
};
export default AllProductVideo;
